export interface NavTabItem {
  key: string;
  path: string;
  title: string;
  closable: boolean;
}

const HOME_TAB: NavTabItem = {
  key: '/dashboard',
  path: '/dashboard',
  title: '首页',
  closable: false,
};

const tabTitleMap: Record<string, string> = {
  '/dashboard': '首页',
  '/products': '产品列表',
  '/duplicate-products': '重复卡对比',
  '/regional-recommendations': '地区推荐',
  '/external-products': '分类',
  '/orders': '订单管理',
  '/marketing': '首页配置',
  '/lottery': '抽奖活动',
  '/users': '用户管理',
  '/settings': '系统设置',
};

export const defaultVisitedTabs: NavTabItem[] = [HOME_TAB];

export const normalizeTabPath = (pathname: string) => {
  const cleanPath = pathname.split('?')[0].replace(/\/+$/, '') || '/';
  return cleanPath === '/' ? HOME_TAB.path : cleanPath;
};

export const getNavTabByPath = (pathname: string): NavTabItem => {
  const path = normalizeTabPath(pathname);

  if (path === HOME_TAB.path) {
    return HOME_TAB;
  }

  const lotteryDetailMatch = path.match(/^\/lottery\/([^/]+)$/);
  if (lotteryDetailMatch) {
    return {
      key: path,
      path,
      title: `抽奖详情 #${lotteryDetailMatch[1]}`,
      closable: true,
    };
  }

  return {
    key: path,
    path,
    title: tabTitleMap[path] || path.replace(/^\//, ''),
    closable: true,
  };
};

export const restoreVisitedTabs = (rawValue: string | null): NavTabItem[] => {
  if (!rawValue) return defaultVisitedTabs;

  try {
    const parsed = JSON.parse(rawValue) as NavTabItem[];
    if (!Array.isArray(parsed)) return defaultVisitedTabs;

    const tabs = parsed
      .filter((item) => item?.path && item?.title)
      .map((item) => ({
        ...item,
        key: normalizeTabPath(item.path),
        path: normalizeTabPath(item.path),
        closable: normalizeTabPath(item.path) !== HOME_TAB.path,
      }));

    const uniqueTabs = new Map<string, NavTabItem>();
    defaultVisitedTabs.forEach((item) => uniqueTabs.set(item.key, item));
    tabs.forEach((item) => uniqueTabs.set(item.key, item));
    return Array.from(uniqueTabs.values());
  } catch {
    return defaultVisitedTabs;
  }
};
